<template>
	<section v-html="fundPerformanceContent" />
</template>

<script>
export default {
	name: "ImportantFundPerformanceInformation",
	computed: {
		fundPerformanceContent() {
			return this.$store.state.content.descriptions.importantFundPerformanceInformation.definition;
		}
	}
};
</script>

<style lang="scss">
#important-fund-performance-information {
	p {
		margin-bottom: 16px;
	}
}
</style>
